import { gstDateTime } from "./gst";

const DAY_MS = 24 * 60 * 60 * 1000;

export const gstAbsolute = (iso: string): string => gstDateTime(iso);

export type IncidentTimeDisplay = { text: string; tooltip: string | null };

export const formatIncidentTime = (iso: string, now: number): IncidentTimeDisplay => {
  const ts = new Date(iso).getTime();
  const diffMs = now - ts;
  const absolute = gstAbsolute(iso);

  if (diffMs >= DAY_MS) {
    return { text: absolute, tooltip: null };
  }

  const diffSec = Math.max(0, Math.floor(diffMs / 1000));
  if (diffSec < 60) {
    return { text: "Just now", tooltip: absolute };
  }
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) {
    return { text: `${diffMin} min ago`, tooltip: absolute };
  }
  const diffHours = Math.floor(diffMin / 60);
  return { text: `${diffHours} h ago`, tooltip: absolute };
};
